import { render, staticRenderFns } from "./CompaniesInApproval.html?vue&type=template&id=785c55fd&lang=html&external"
import script from "./CompaniesInApproval.vue?vue&type=script&lang=js"
export * from "./CompaniesInApproval.vue?vue&type=script&lang=js"
import style0 from "./CompaniesInApproval.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports